import axios from 'axios';

// remote server

const prod = {
    url: `https://back.tctrading.co`,
    baseURL: `https://back.tctrading.co`,
}
const dev = {
    url: `localhost:3001`
}
export default axios.create(process.env.REACT_APP_ENV == 'development' ? dev : prod);